import axiosInstance from "../../axios/instance";
import { normalizeToUTC } from "@revbox/helpers-fe";
import { getToken } from "../../helpers/get-token";
async function getSpecificInventoryPositions(inventoryId, currentPeriod) {
    try {
        const token = getToken();
        axiosInstance.defaults.headers.common['authorization'] = token;
        const response = await axiosInstance.post(process.env.REACT_APP_HUB_URL + '/api/missed-clicks/inventory-specific-positions/' + inventoryId, {
            current_period: [
                normalizeToUTC(currentPeriod[0]).getTime(),
                normalizeToUTC(currentPeriod[1]).getTime()
            ]
        })
        return response?.data;
    } catch (error) {
        console.log(error);
    }
}

export default getSpecificInventoryPositions;
